import { exponeaStartConfig } from '@config/config';
import { createContext, useContext, useState, useEffect } from 'react';

const CookiebotContext = createContext();

export const useCookiebot = () => useContext(CookiebotContext);

export const CookiebotProvider = ({ children }) => {
  const [cookieConsent, setCookieConsent] = useState({});
  const [exponea, setExponea] = useState({});
  const [dataLayer, setDataLayer] = useState({});

  const updateConsent = () => {
    if (window.Cookiebot) {
      const consent = window.Cookiebot.consent;
      setCookieConsent(consent);
    }
  };

  // const createSafeExponea = (exponea) => {
  //   const safeExponea = new Proxy({}, {
  //     get: (target, prop) => {
  //       if (prop in exponea) {
  //         return (...args) => {
  //           if (typeof exponea[prop] === 'function') {
  //             return exponea[prop](...args);
  //           } else {
  //             // console.warn(`Exponea property ${String(prop)} is not a function.`);
  //           }
  //         };
  //       } else {
  //         // console.warn(`Exponea method ${String(prop)} is not available.`);
  //       }
  //     },
  //   });

  //   return safeExponea;
  // };

  const createSafeExponea = (exponea) => {
    // const safeExponea = new Proxy({}, {
    //   get: (target, prop) => {
    //     if (prop in exponea) {
    //       return (...args) => {
    //         if (typeof exponea[prop] === 'function') {
    //           return exponea[prop](...args);
    //         } else {
    //           // console.warn(`Exponea property ${String(prop)} is not a function.`);
    //         }
    //       };
    //     } else {
    //       // console.warn(`Exponea method ${String(prop)} is not available.`);
    //     }
    //   },
    // });

    return exponea;
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (!window.dataLayer) {
        window.dataLayer = [];
      }
      setDataLayer(window.dataLayer);
    }
  }, []);

  useEffect(() => {
    const checkForCookieConsent = () => {
      if (window.Cookiebot) {
        updateConsent();
        document.addEventListener('CookiebotOnConsentReady', updateConsent);
        return true;
      }
      return false;
    };

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' && document.querySelector('#Cookiebot')) {
          const intervalId = setInterval(() => {
            if (checkForCookieConsent()) {
              clearInterval(intervalId);
              observer.disconnect();
            }
          }, 100);
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: false });

    return () => {
      observer.disconnect();
      document.removeEventListener('CookiebotOnConsentReady', updateConsent);
    };
  }, []);

  // useEffect(() => {
  //   if (window.exponea) {
  //     window.exponea.start(exponeaStartConfig);
  //   }
  // }, []);

  useEffect(() => {
    if (window.exponea && cookieConsent.marketing) {
      window.exponea.start(exponeaStartConfig);
      setExponea(createSafeExponea(window.exponea));
    } else {
      setExponea({});
    }
  }, [cookieConsent.marketing]);

  return (
    <CookiebotContext.Provider value={{ cookieConsent, exponea, dataLayer }}>
      {children}
    </CookiebotContext.Provider>
  );
};